export { Footer } from './Footer';
export { getFooterLinks } from './data/footerData';
export * from './types';
